import * as Types from './types';
import axios from 'axios';
import { AppConfig } from 'AppConfig';
import * as AppActionTypes from 'store/actions/appstate';

export const SHOULD_REFRESH_INIT_VALUE = 0;

export const uploadDefaultLogo = (lightLogoFile, darkLogoFile) => {
  return (dispatch) => {
    let formData = new FormData();
    if (lightLogoFile) {
      formData.append('lightLogoFile', lightLogoFile);
    }
    if (darkLogoFile) {
      formData.append('darkLogoFile', darkLogoFile);
    }

    axios
      .post(AppConfig.FO_INITIAL_URL + `/tenant-logo/v2/default`, formData)
      .then((m) => {
        dispatch({
          type: Types.UPLOAD_LOGO_SUCCESS
        });
      })
  };
};

export const uploadTenantLogo = (tenantCode, lightLogoFile, darkLogoFile) => {
  return (dispatch) => {
    let formData = new FormData();
    if (lightLogoFile) {
      formData.append('lightLogoFile', lightLogoFile);
    }
    if (darkLogoFile) {
      formData.append('darkLogoFile', darkLogoFile);
    }

    axios
      .post(
        AppConfig.FO_INITIAL_URL + `/tenant-logo/v2/tenant/${tenantCode}`,
        formData
      )
      .then((m) => {
        dispatch({
          type: Types.UPLOAD_LOGO_SUCCESS
        });
      })
      .catch((err) => {
        dispatch({
          type: AppActionTypes.APPSTATE_SET_APP_ERROR,
          payload: err?.response?.data?.msg || 'Failed to upload tenant logos.'
        });
      })
  };
};

export const deleteLogo = (tenantCode) => {
  return (dispatch) => {
    axios
      .delete(AppConfig.FO_INITIAL_URL + `/tenant-logo/v2/tenant/${tenantCode}`)
      .then((m) => {
        if (m.data.logoCode === 'DELETION_SUCCESS') {
          dispatch({
            type: Types.DELETION_SUCCESS
          });
        } else {
          dispatch({
            type: AppActionTypes.APPSTATE_SET_APP_ERROR,
            payload: m.data.msg
          });
        }

      })
      .catch((err) => {
        //send to global logo
        //do nothing for now
      });
  };
};

export const uploadBrokerLogo = (brokerCode, lightLogoFile, darkLogoFile) => {
  return (dispatch) => {
    let formData = new FormData();
    if (lightLogoFile) {
      formData.append('lightLogoFile', lightLogoFile);
    }
    if (darkLogoFile) {
      formData.append('darkLogoFile', darkLogoFile);
    }

    axios
      .post(
        AppConfig.FO_INITIAL_URL + `/tenant-logo/v2/broker/${brokerCode}`,
        formData
      )
      .then(() => {
        dispatch({
          type: Types.UPLOAD_LOGO_SUCCESS
        });
      })
      .catch((err) => {
        dispatch({
          type: AppActionTypes.APPSTATE_SET_APP_ERROR,
          payload: err?.response?.data?.msg || 'Failed to upload broker logos.'
        });
      });
  };
};

export const deleteBrokerLogo = (brokerCode) => {
  return (dispatch) => {
    axios
      .delete(AppConfig.FO_INITIAL_URL + `/tenant-logo/v2/broker/${brokerCode}`)
      .then((m) => {
        if (m.data.logoCode === 'DELETION_SUCCESS') {
          dispatch({
            type: Types.DELETION_SUCCESS
          });
        } else {
          dispatch({
            type: AppActionTypes.APPSTATE_SET_APP_ERROR,
            payload: m.data.msg
          });
        }
      })
      .catch((err) => {
        //do nothing for now
      });
  };
};

export const deleteTenantLogoByType = (tenantCode, logoType) => {
  return (dispatch) => {
    return axios
      .delete(AppConfig.FO_INITIAL_URL + `/tenant-logo/v2/tenant/${tenantCode}/${logoType}`)
      .then((m) => {
        if (m.data.logoCode === 'DELETION_SUCCESS') {
          dispatch({
            type: Types.DELETION_SUCCESS
          });
        } else {
          dispatch({
            type: AppActionTypes.APPSTATE_SET_APP_ERROR,
            payload: m.data.msg
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: AppActionTypes.APPSTATE_SET_APP_ERROR,
          payload: err?.response?.data?.msg || 'Failed to delete tenant logo.'
        });
      });
  };
};

export const deleteBrokerLogoByType = (brokerCode, logoType) => {
  return (dispatch) => {
     return axios
      .delete(AppConfig.FO_INITIAL_URL + `/tenant-logo/v2/broker/${brokerCode}/${logoType}`)
      .then((m) => {
        if (m.data.logoCode === 'DELETION_SUCCESS') {
          dispatch({
            type: Types.DELETION_SUCCESS
          });
        } else {
          dispatch({
            type: AppActionTypes.APPSTATE_SET_APP_ERROR,
            payload: m.data.msg
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: AppActionTypes.APPSTATE_SET_APP_ERROR,
          payload: err?.response?.data?.msg || 'Failed to delete broker logo.'
        });
      });
  };
};
